import React, { FC } from 'react';
import { useTrackElement } from '@edreamsodigeo/frontend-core';
import AlternativeFlightBrokenFlowVersioned from './AlternativeFlightBrokenFlow';
import { usePersistedFlightSelection } from 'clientState/hooks/usePersistedFlightSelection/usePersistedFlightSelection';

const AlternativeFlightModal: FC = () => {
  const [flightSelectionData] = usePersistedFlightSelection();

  const displayTracking = useTrackElement(
    ['display'],
    `alternative-flights-modal-error-searchId-${flightSelectionData?.data?.searchId}-itineraryId-${flightSelectionData?.data?.fareItineraryKey}`
  );

  return (
    <div ref={displayTracking}>
      <AlternativeFlightBrokenFlowVersioned />
    </div>
  );
};

export default AlternativeFlightModal;
